import { render, staticRenderFns } from "./userinfo2.vue?vue&type=template&id=62fc0552&scoped=true"
import script from "./userinfo2.vue?vue&type=script&lang=js"
export * from "./userinfo2.vue?vue&type=script&lang=js"
import style0 from "./userinfo2.vue?vue&type=style&index=0&id=62fc0552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fc0552",
  null
  
)

export default component.exports